<div class="modals" [class.modals-show]="isModalShow">
  <div class="np-nalojki-info-head">
    Увага! <br> Ви оформлюєте накладений платіж!
  </div>
  <div class="np-nalojki-info-buttons-container">
    <button class="button" (click)="notAgree()">Не згоден</button>
    <button class="button" (click)="agree()">Згоден</button>
    <button class="button" (click)="agreeNotShowMore()">
      Згоден більше не нагадувати
    </button>
  </div>
</div>
<div class="dark-layer" [class.modals-show]="isDarkBackground"></div>

